import React, { useRef } from 'react';
import { useInViewport, useHover } from '@fuxi/eevee-hooks';
import { InfiniteScrollContainer, ContainerProps } from './styles';

type ScrollProps = {
  ifHoverPaused?: boolean;
  wrapperStyle?: React.CSSProperties;
  children?: React.ReactNode;
} & ContainerProps;

export const InfiniteScroll = (props: ScrollProps) => {
  const ref = useRef(null);
  const [inViewport] = useInViewport(ref);
  const isHovering = useHover(ref);

  return (
    <InfiniteScrollContainer
      style={props.wrapperStyle}
      {...props}
      ifStart={inViewport && (props.ifHoverPaused ? !isHovering : true)}
      ref={ref}>
      <div className="list-wrapper">
        <div className="list-content-wrapper">{props.children}</div>
      </div>
    </InfiniteScrollContainer>
  );
};
